import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["isEditMode", "isNewFile", "id", "assetId", "fileName"];
import React from 'react';
import { useTranslation } from 'react-i18next';
import Box from 'components/Box';
import OverflowTooltip from 'components/OverflowTooltip';
import AssetDownloadLink from 'components/AssetDownloadLink';
import FormField from 'components/FormField';
import useUniqueId from 'hooks/useUniqueId';
var FileNameField = function FileNameField(_ref) {
  var isEditMode = _ref.isEditMode,
    isNewFile = _ref.isNewFile,
    id = _ref.id,
    assetId = _ref.assetId,
    fileName = _ref.fileName,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var uniqueId = useUniqueId(id);
  return /*#__PURE__*/React.createElement(FormField, _extends({
    label: t('form_file_name_colon'),
    labelId: uniqueId
  }, otherProps), isEditMode ? /*#__PURE__*/React.createElement(OverflowTooltip, {
    content: fileName
  }, /*#__PURE__*/React.createElement(Box, {
    overflow: "ellipsis"
  }, isNewFile || !assetId ? fileName : /*#__PURE__*/React.createElement(AssetDownloadLink, {
    assetId: assetId
  }, fileName))) : /*#__PURE__*/React.createElement(OverflowTooltip, {
    content: fileName
  }, fileName));
};
export default FileNameField;